import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/otrosEquipos/EquipoEyector/EquipoEyector1.png';
import Img2 from '../../img/products/otrosEquipos/EquipoEyector/EquipoEyector2.png';

const EquipoEyector = () => {
    const navigate = useNavigate();

    return (
        <div className="container my-5">
            <h2 className="mb-4 text-center">Equipo Eyector</h2>
            <div className="row align-items-start mb-2">
                {/* Columna Izquierda: texto descriptivo */}
                <div className="col-md-7">
                    <p className="lead text-justify">
                        El equipo de bombeo de agua con Eyector es una solución eficiente para aumentar la capacidad
                        de succión y la presión del agua en sistemas de bombeo. Este tipo de equipo es especialmente
                        útil en aplicaciones donde la fuente de agua está a una profundidad considerable o donde se
                        requiere una mayor presión de agua.
                    </p>
                    <p className="lead text-justify">
                        Este equipo permite aumentar la profundidad de succión, lo que es ideal para pozos profundos
                        y otras aplicaciones subterráneas. También manejamos equipo Eyector para Pozo Seco, este tipo
                        de equipo es especialmente útil en aplicaciones donde la fuente de agua no está en contacto
                        continuo, la bomba no necesita estar sumergida o en contacto directo con el fluido, lo que
                        permite una mayor flexibilidad en su ubicación e instalación.
                    </p>
                </div>
                {/* Columna derecha: imágenes en cuadrícula */}
                <div className="col-md-5">
                    <div className="row g-2">
                        <div className="col-6">
                            <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Eyector 1" />
                        </div>
                        <div className="col-6">
                            <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Eyector 2" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EquipoEyector;
